module.exports = __webpack_public_path__ + "static/media/instruction01.ab7070d1.png";